module.exports = __webpack_public_path__ + "static/media/ab.011b8944.png";